// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KpeLayout_wrapper__3Vp0a"};